module.exports = __webpack_public_path__ + "static/media/starwars.c17d2e6.mid";


//////////////////
// WEBPACK FOOTER
// ./src/assets/starwars.mid
// module id = VILj
// module chunks = 0